export const adaptProveedorDistribuidor = (proveedorDistribuidorData) => {
    return {
        id: proveedorDistribuidorData?.idProveedorDistribuidor,
        codigo: proveedorDistribuidorData?.codigoSAP,
        razonSocial: proveedorDistribuidorData?.razonSocial,  
        deposito: proveedorDistribuidorData?.idDepositoNavigation?.descripcion,      
        activo : proveedorDistribuidorData?.activo,
        Bulto : proveedorDistribuidorData?.proveedorMetodoCobroBulto.length > 0,
        Kilo : proveedorDistribuidorData?.proveedorMetodoCobroKilo.length > 0,
        Km : proveedorDistribuidorData?.proveedorMetodoCobroKM.length > 0,
        vencimientoBulto: proveedorDistribuidorData?.proveedorMetodoCobroBulto[0]?.fechaHasta,
        vencimientoKilo: proveedorDistribuidorData?.proveedorMetodoCobroKilo[0]?.fechaHasta,
        vencimientoKM: proveedorDistribuidorData?.proveedorMetodoCobroKM[0]?.fechaHasta
    }
}

export const adaptProveedorDistribuidorArray = (
    proveedorDistribuidorData
) => {
    return structuredClone(proveedorDistribuidorData)
        ?.map(proveedores => adaptProveedorDistribuidor(proveedores));
}